import React from "react";
import "./BatterjeeGroup.css";
import bgImage from "../assets/images/batterjee-group.jpg";
import separador from "../assets/images/separador.png";
import degrad from "../assets/images/degrad-inf-dcha.png";


const BatterjeeGroup = () => {
  return (
    <>
      {/* IMAGE SECTION */}
      <section
        className="batterjee-hero"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="batterjee-overlay"></div>
      </section>

      {/* CONTENT SECTION (AFTER IMAGE) */}
      <section className="batterjee-stats-section">
        <div className="batterjee-stats">
          <div className="stat-item">
            <h2>
              1<span>st</span>
            </h2>
            <p>
              laboratory <br />
              in the Spanish pharmaceutical market
            </p>
  <span className="stat-line"></span>
             <img src={separador} alt="" className="stat-corner" />
</div>
      

          <div className="stat-item">
            <h2>2,300</h2>
            <p>professionals</p>
  <span className="stat-line"></span>
             <img src={separador} alt="" className="stat-corner" />
</div>
          
          <div className="stat-item">
            <h2>
              <span className="currency">$</span>820
              <span className="small">M</span>
            </h2>
            <p>in revenue generated in 2024 (+10%)</p>
            <span className="stat-line"></span>
             <img src={separador} alt="" className="stat-corner" />
          </div>

          <div className="stat-item">
            <h2>
              80<span className="small">%</span>
            </h2>
            <p>
              of profits reinvested in companies within the Group on average over
              the last decade
            </p>
<span className="stat-line"></span>
             <img src={separador} alt="" className="stat-corner" />            
          </div>
        </div>
      </section>

      <section className="international-section">
  <div className="international-grid">

    {/* LEFT CONTENT */}
    <div className="international-left">
      <h2 className="international-title">
        <span className="green">Inter</span><span className="purple">national</span>
      </h2>

      <p className="international-desc">
        We adapt to each market, country and individual, adapting our portfolio
        to the specific needs of each region where we do business while meeting
        local requirements.
      </p>

      {/* MAP IMAGE */}
      <img
        src={require("../assets/images/batterjee-mapa.png")}
        alt="International presence"
        className="international-map"
      />
    </div>

    {/* RIGHT CONTENT */}
    <div className="international-right">
      <span className="international-line"></span>
       <img src={separador} alt="" className="stat-corner-international" />

      <div className="international-stat">
        <h3>
          26<span>%</span>
        </h3>
        <p>of revenue from international business</p>
      </div>

      <div className="international-stat">
        <h4>Operations in</h4>
        <h3>
          +100 <span>countries</span>
        </h3>

        <ul>
          <li>Operating under the Cinfa brand in Middle East, Latin America, Asia, Francophone Africa.</li>
          <li>Operating under other Cinfa Group brands in France and Italy.</li>
          <li>R&amp;D partnerships with universities, research centres and hospitals.</li>
          <li>B2B partnerships.</li>
        </ul>
      </div>
    </div>

  </div>
</section>
<section className="rd-section">
  <div className="rd-bg">

    {/* IMAGE */}
    <img
      src={require("../assets/images/rd-lab.jpg")}
      alt="R&D Lab"
      className="rd-bg-img"
    />

    {/* FADE OVER IMAGE */}
    <div className="rd-overlay"></div>

    {/* CONTENT */}
    <div className="rd-content">
      <h2 className="rd-title">
        <span className="green">R&amp;D</span>
        <span className="purple">+i</span>
      </h2>

      <div className="rd-stats">
        <div className="rd-stat">
          <span className="rd-line"></span>
          <img src={separador} alt="" className="rg-corner" />
          <h3><span className="currency">$</span>514<span className="small">M</span></h3>
          <p>invested in R&amp;D+i and infrastructures over the last decade</p>
        </div>

        <div className="rd-stat">
          <span className="rd-line"></span>
          <img src={separador} alt="" className="rg-corner" />
          <h3>+140</h3>
          <p>people work in the R&amp;D+i areas of the Group</p>
        </div>

        <div className="rd-stat">
          <span className="rd-line"></span>
          <img src={separador} alt="" className="rg-corner" />
          <h3>+80</h3>
          <p>partnerships with universities and research centres worldwide</p>
        </div>
      </div>
    </div>

  </div>
</section>
{/* CINFA GROUP INTRO SECTION */}
<section className="cinfa-intro-section">
  <div className="cinfa-intro-wrapper">

    <div className="cinfa-intro-title">
      <h2>
        <span className="green">Batterjee</span><br />
        <span className="purple">Group</span>
      </h2>
    </div>

    <div className="cinfa-intro-text">
      <p>
        Batterjee Group is made up by various companies from the health and
        pharmaceutical sector in Spain, France and Italy that bring our
        products to customers around the world from their corresponding
        central headquarters.
      </p>
    </div>

  </div>
</section>
{/* GROUP COMPANIES SECTION */}
<section className="group-companies-section">
  <div className="group-companies-grid">

    {/* LEFT COLUMN */}
    <div className="company-col">
 <div className="company-card">
 <img src={require("../assets/images/logo.png")} alt="Cinfa" />

  <div className="company-info">
    <span className="location">📍 Spain</span>
    <p>Leader in the Spanish pharmaceutical market</p>
  </div>
  <span className="company-line"></span>
  <img src={degrad} alt="" className="rg-corner" />
</div>

      <div className="company-card">
        <img src={require("../assets/images/logo-natural-sante.png")} alt="Orliman" />
        <div className="company-info">
          <span className="location">📍 Spain and France</span>
          <p>Leader in the Spanish orthopaedic market</p>
        </div>
        <span className="company-line"></span>
        <img src={degrad} alt="" className="rg-corner" />
      </div>

      <div className="company-card">
        <img src={require("../assets/images/loog-orliman.png")} alt="Cyndea" />
        <div className="company-info">
          <span className="location">📍 Spain</span>
          <p>Steroid based medicines and cancer treatments</p>
        </div>
        <span className="company-line"></span>
        <img src={degrad} alt="" className="rg-corner" />

      </div>

    </div>

    {/* RIGHT COLUMN */}
    <div className="company-col">

      <div className="company-card">
        <img src={require("../assets/images/logo-sakura.png")} alt="Natural Santé" />
        <div className="company-info">
          <span className="location">📍 France</span>
          <p>Food supplements of natural origin</p>
        </div>
        <span className="company-line"></span>
        <img src={degrad} alt="" className="rg-corner" />
      </div>

      <div className="company-card">
        <img src={require("../assets/images/logo-cyndea.png")} alt="Sakura" />
        <div className="company-info">
          <span className="location">📍 Italy</span>
          <p>Healthcare products and food supplements</p>
        </div>
        <span className="company-line"></span>
        <img src={degrad} alt="" className="rg-corner" />
      </div>

    </div>

  </div>
</section>




    </>
  );
};

export default BatterjeeGroup;
